export enum AppTitle {
    main = 'Corrections',
}
